// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MhA5DqmeojkWLevo {
  display: flex;
  background-color: #f3f5f7;
  margin-left: 315px;
  margin-top: 97px;
  min-height: calc(100vh - 97px);
}

.NsPclWKOP1Eejym4 {
  flex: 1;
  padding: 20px;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .MhA5DqmeojkWLevo {
    margin-top: 65px;
    min-height: calc(100vh - 65px);
  }
}

@media screen and (max-width: 1104px) {
  .MhA5DqmeojkWLevo {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/AdminDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".adminPortal {\r\n  display: flex;\r\n  background-color: #f3f5f7;\r\n  margin-left: 315px;\r\n  margin-top: 97px;\r\n  min-height: calc(100vh - 97px);\r\n}\r\n\r\n.routeContainer {\r\n  flex: 1;\r\n  padding: 20px;\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .adminPortal {\r\n    margin-top: 65px;\r\n    min-height: calc(100vh - 65px);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1104px) {\r\n  .adminPortal {\r\n    margin-left: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var adminPortal = `MhA5DqmeojkWLevo`;
export var routeContainer = `NsPclWKOP1Eejym4`;
export default ___CSS_LOADER_EXPORT___;
